import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from '../../shared/services/api.service';
import { AuthService } from '../../shared/services/auth.service';
import { UtilService } from '../../shared/services/util.service';

@Component({
  standalone: false,
  selector: 'app-mfa-login',
  templateUrl: './mfa-login.component.html',
  styleUrls: ['./mfa-login.component.scss']
})
export class MfaLoginComponent implements OnInit {
  userEmail: string = '';
  otp: string = '';
  errorMessage: string | null = null;
  isLoading: boolean = false;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private utilService: UtilService,
    private router: Router
  ) { }

  ngOnInit(): void {
    // Get user email from auth service
    const user = this.authService.getUser();
    if (user && user.email) {
      this.userEmail = user.email;
    } else {
      // Redirect to login if no user data
      this.router.navigate(['/']);
    }
  }

  onOtpChange(event: any): void {
    const value = event.target.value;
    // Allow only numeric values and limit to 6 digits
    if (/^\d*$/.test(value) && value.length <= 6) {
      this.otp = value;
    }
  }

  verifyMfaToken(): void {
    if (!this.otp || this.otp.length !== 6) {
      this.errorMessage = 'Please enter a valid 6-digit code';
      return;
    }

    this.isLoading = true;
    this.errorMessage = null;

    const payload = {
      email: this.userEmail,
      token: this.otp
    };

    this.apiService.postData('/users/totp-mfa/verify', payload).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        if (res && !res.error) {
          // Update user data with new token and mark MFA as verified
          const user = res.data;
          user.mfaVerified = true;
          this.authService.setUser(user);
          // Navigate to dashboard
          this.utilService.navigate('/app');
        } else {
          this.errorMessage = res.message || 'Invalid token. Please try again.';
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.errorMessage = 'Verification failed. Please try again.';
      }
    });
  }

  cancelMfa(): void {
    // Clear user data and redirect to login
    this.authService.logout();
  }
}